import cn from 'classnames';
import {FormikProps} from 'formik';
import {IProductForm} from './productFormData';

interface Props {
  image: string;
  title: string;
  guid: string;
  code: number;
  form: FormikProps<IProductForm>;
}

const InputItem = ({image, title, guid, code, form}: Props) => {
  const isSelected = form?.values.inputGuid === guid;

  return (
    <div
      className={cn(
        'flex flex-col gap-1 justify-center items-center bg-white rounded-xl transition-colors duration-200 cursor-pointer w-[76px] shadow-xs h-[90px] border-[1px]',
        isSelected
          ? 'border-[1px] border-green-main'
          : 'border-gray-300 hover:border-gray-400',
      )}
      onClick={() => {
        form?.setFieldValue('inputGuid', guid);
        form?.setFieldValue('inputName', title);
        form?.setFieldValue('inputCode', code);
      }}
    >
      <div className="h-[50%] w-12">
        <img
          src={image}
          alt={title}
          className="object-contain h-full"
          loading="lazy"
        />
      </div>
      <span
        className={cn(
          'text-xs font-semibold',
          isSelected ? 'text-green-700' : 'text-gray-900',
        )}
      >
        {title}
      </span>
    </div>
  );
};

export default InputItem;
